const IconInHouse = ({ size, color, ...props }) => (
    <svg width={size} height={size} viewBox="0 0 16 15" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
        <path
            d="M15.5 7.01706C15.5 6.69989 15.3495 6.40152 15.0945 6.21297L8.5945 1.4073C8.2412 1.1461 7.7588 1.1461 7.40551 1.4073L0.905504 6.21297C0.650466 6.40152 0.5 6.69989 0.5 7.01707V14.9678C0.5 15.5201 0.947715 15.9678 1.5 15.9678H14.5C15.0523 15.9678 15.5 15.5201 15.5 14.9678V7.01706Z"
            fill={color}
        />
        <path
            d="M11.9226 12.7366C9.60959 12.7366 8.64381 12.0245 8.64381 10.2504C8.64381 8.30041 9.75568 7.97285 11.9226 7.97285C12.0477 7.97285 12.1681 7.97511 12.2857 7.97875V7.48022C10.1711 7.30809 9.00706 6.72502 8.00007 6.3252C6.99307 6.72502 5.82903 7.30809 3.71446 7.48013V7.97865C3.83211 7.97501 3.95255 7.97275 4.0775 7.97275C6.24446 7.97275 7.35633 8.30032 7.35633 10.2503C7.35633 12.0244 6.39055 12.7365 4.0775 12.7365L3.71436 12.7392V13.2895H12.2858V12.7392L11.9226 12.7366Z"
            fill="#F6F5F4"
        />
    </svg>
);

export default IconInHouse;
